export default {
  isLoggedIn(state) {
    return state.auth.token !== null
  },
}
